import { Provider } from '@angular/core';
import { getMsalProviders } from '@app/auth/msal/configs';
import { getOktaProviders } from '@app/auth/okta/configs';
import { authServiceFactory } from '@auth/auth.factory';
import { AUTH_SERVICE } from '@auth/auth.token';
import { authProviders } from '@auth/constants/auth-provider.constant';
import { AppConfig } from '@core/models/config.models';

/**
 * Get auth-specific providers based on the configuration.
 * This function returns providers conditionally based on the auth provider type.
 */
export function provideAuth(config: AppConfig): Provider[] {
  const providers: Provider[] = [
    {
      provide: AUTH_SERVICE,
      useFactory: authServiceFactory,
    },
  ];

  switch (config.auth.provider) {
    case authProviders.Okta:
      providers.push(...getOktaProviders(config.auth));
      break;
    case authProviders.Entra:
      providers.push(...getMsalProviders(config));
  }

  return providers;
}
